import { render, staticRenderFns } from "./PendingAccessCodeList.vue?vue&type=template&id=1275e4e1&scoped=true&"
import script from "./PendingAccessCodeList.vue?vue&type=script&lang=js&"
export * from "./PendingAccessCodeList.vue?vue&type=script&lang=js&"
import style0 from "./PendingAccessCodeList.vue?vue&type=style&index=0&id=1275e4e1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1275e4e1",
  null
  
)

export default component.exports